// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-icon[data-v-d2d84e1c]{align-items:center;justify-content:center;background-color:#eee;border-radius:initial!important;font-size:25px}.form-row[data-v-d2d84e1c]{margin-bottom:0!important}.add-form .customer-work[data-v-d2d84e1c]{position:relative}.add-form .customer-work[data-v-d2d84e1c]:not(.first-item){border-top:1px solid #000;padding-top:15px;margin-top:15px}.add-form .customer-work .remove-button[data-v-d2d84e1c]{color:red;position:absolute;right:0;cursor:pointer}", ""]);
// Exports
module.exports = exports;
